import { useState } from "react";
import { Button } from "../../../components/buttons/button";
import { ProfileIcon } from "../../../components/cards/profilePic";
import { BgWrapper } from "../../../components/wrapper/bgWrapper";
import { CreatedEvent } from "../../../redux/features/event/event.types";
import {
  copyTextToClipboard,
  getEventUrl,
  handleShare,
} from "../../../utils/helpers";

export const PreviewOrganizerDetails = ({
  event,
  className = "",
  canShare,
}: {
  event?: CreatedEvent;
  className?: string;
  canShare: boolean;
}) => {
  const [buttonText, setButtonText] = useState("Copy Link");

  const handleCopy = async () => {
    await copyTextToClipboard(getEventUrl(event?.slug ?? ""));
    setButtonText("Copied!");
    setTimeout(() => {
      setButtonText("Copy Link");
    }, 2000);
  };
  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      <div className="order-last grid grid-cols-2 items-center gap-3 md:order-first">
        <Button
          type="button"
          onClick={handleCopy}
          icon="link"
          text={buttonText}
          variation="white"
          className="!rounded-2xl !p-3"
          disabled={!canShare}
        />

        <Button
          type="button"
          onClick={async () => {
            await handleShare("", "", getEventUrl(event?.slug ?? ""));
          }}
          icon="upload"
          text={"Share Event"}
          variation="white"
          className="!rounded-2xl !p-3"
          disabled={!canShare}
        />
      </div>

      <BgWrapper>
        <p className="text-sm text-grey-500">
          {event?.createdBy?.isOrganisation ? "Organized by" : "Organized by"}
        </p>

        <div className="mt-1 flex items-center gap-[6px]">
          {event?.createdBy?.isOrganisation ? (
            <img
              alt="organization logo"
              src={event?.createdBy?.organisation?.logo}
              className={`max-h-[24px] min-h-[24px] min-w-[24px] max-w-[24px] overflow-hidden rounded-[4px] object-cover ${!event?.createdBy?.organisation?.logo && "hidden"}`}
            />
          ) : (
            <ProfileIcon dimension={24} className="!p-[4.5px]" />
          )}

          <p className="text-base font-bold text-primary">
            {event?.createdBy?.isOrganisation
              ? `${event?.createdBy?.organisation?.name}`
              : `${event?.createdBy?.firstName} ${event?.createdBy?.lastName}`}
          </p>
        </div>
      </BgWrapper>
    </div>
  );
};
